import { DialogActionsBar } from '@progress/kendo-react-dialogs';
import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import React, { useCallback } from 'react';
import Button from 'src/components/design-system/Button';
import DropDown from 'src/components/design-system/DropDown';
import useReceiptDetails from 'src/hooks/useReceiptDetails';
import { DropDownListDataItem } from 'src/types/generic';

interface IAssignGLWizard {
  showModal: (modalName: string, data?: any) => void;
  updateGLItems: (glCode: string) => void;
}

const BulkAssignGLWizard: React.FC<IAssignGLWizard> = ({ showModal, updateGLItems }) => {
  const { glCodeOptions } = useReceiptDetails();
  const [glCode, setGLCode] = React.useState<DropDownListDataItem>({ label: '', value: '' });
  const handleAssignGLCodes = async () => {
    if (glCode.value !== '') {
      updateGLItems(glCode.value);
      showModal('Bulk Assign GL Codes');
    }
  };

  const handleChange = useCallback(
    (e: DropDownListChangeEvent) => {
      setGLCode(e.value);
    },
    [setGLCode]
  );

  return (
    <>
      <div className="mb-2">
        <p className="mb-2" style={{ lineHeight: '1.5', fontWeight: 'bold' }}>
          Pick the GL Code to assign to all selected line items:
          <DropDown options={glCodeOptions as any} value={glCode.value} onChange={handleChange} />
        </p>
      </div>
      <DialogActionsBar>
        <div className="flex  flex-row justify-end gap-2">
          <Button disabled={!glCode?.value} onClick={handleAssignGLCodes}>
            Bulk Assign GL Codes
          </Button>
          <Button color="info" onClick={() => showModal('Bulk Assign GL Codes')}>
            Cancel
          </Button>
        </div>
      </DialogActionsBar>
    </>
  );
};

export default BulkAssignGLWizard;
